<template>
    <div class="row">
        <div class="col-12 col-md-8">
            <div class="card">
                <div class="card-header bg-info my-0 mx-0" style="border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important;">
                    <h4 class="my-0">Página de Bloqueo</h4>
                </div>
                <div class="card-body my-0 mx-0 border-top-no-radius" style="border-top-left-radius: 0 !important; border-top-right-radius: 0 !important;">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="control-label">
                                    Imagen de bloqueo
                                </label>
                                <el-upload :action="`/${resource}/upload`"
                                           :data="{'type': 'img'}"
                                           :headers="headers"
                                           accept="image/*"
                                           :on-success="onSuccess"
                                           :show-file-list="false"
                                           :before-upload="beforeUpload"
                                           class="avatar-uploader">
                                    <img v-if="form.url_img_blockade"
                                         :src="form.url_img_blockade"
                                         class="avatar">
                                    <i v-else
                                       class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </div>
                        </div>  
                        <div class="col-12">
                            <div class="form-group">
                                <label class="control-label">
                                    Mensaje de Bloqueo
                                </label>
                                <vue-ckeditor
                                    type="classic"
                                    v-model="form.message_blockade"
                                    :editors="editors"
                                ></vue-ckeditor>
                            </div>
                        </div>
                        <div class="col-12 text-right mt-4">
                            <el-button type="primary"
                                @click="submit"
                                :loading="loading"
                            >Guardar</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
    import VueCkeditor from "vue-ckeditor5"

    export default {
        components: {
            "vue-ckeditor": VueCkeditor.component
        },
        data() {
            return {
                resource: 'blockade',
                loading: false,
                form: {
                    name_img_blockade: null,
                    url_img_blockade: null,
                    file_img_blockade: null,
                    img_extension: null,
                    message_blockade: null
                },
                editors: {
                    classic: ClassicEditor,
                },
                headers: headers_token,
            }
        },
        async created() {
            const { data } = await this.$http.get(`/${this.resource}`)
            this.form.message_blockade = data.data.message_blockade || null
            this.form.name_img_blockade = data.data.img_blockade || null
            this.form.url_img_blockade = data.data.url_img_blockade || null
        },
        methods: {
            async submit() {
                this.loading = true
                const response = await this.$http.put(`/${this.resource}`, this.form)
                this.$message.success(response.data.message)
                this.loading = false
            },

            onSuccess(response) {
                if (response.success) {
                    this.form.name_img_blockade = response.data.filename
                    this.form.url_img_blockade = response.data.temp_image
                    this.form.file_img_blockade = response.data.temp_path
                    this.form.img_extension = response.data.extension
                } else {
                    this.$message.error(response.message)
                }
            },

            beforeUpload(file) {
                const allowedTypes = ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.webp']
                const ext = file.name.slice(file.name.lastIndexOf('.'))
                const isValid = allowedTypes.includes(ext)
                if (!isValid) {
                    this.$message.error('Solo se permiten archivos de imagen')
                }
                return isValid
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/blockade/index.vue